webpackJsonp([59695307820160],{

/***/ 749:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":2,"edges":[{"node":{"fields":{"slug":"/team-tacos-meeting/"},"excerpt":"We love our team get togethers. We shared sun, fun, food, then some shade. Some Owlettes took to the pool to escape the heat. Pot luck tacos…","timeToRead":3,"frontmatter":{"title":"Team Meeting - August","category":"team meetings"}}},{"node":{"fields":{"slug":"/Harry-Potter-Team-Meeting/"},"excerpt":"Sometimes we just like to get together and have fun. As Team Ohana, we like to try to invite our team together once a month to team build…","timeToRead":2,"frontmatter":{"title":"Harry Potter Team Meeting","category":"team meetings"}}}]},"site":{"siteMetadata":{"facebook":{"appId":"885294908345276"}}}},"pathContext":{"category":"team meetings"}}

/***/ })

});


// WEBPACK FOOTER //
// path---category-team-meetings-c2a92e42e20133341974.js